/* eslint-disable max-len */
import React from 'react'
import { ShimmerCircularImage,ShimmerButton,ShimmerBadge, ShimmerTitle } from 'react-shimmer-effects'

function ProfileSkeleton({HeaderData}) {
    return (
        <>
            <div className="bg-[#d6d6d6] lg:px-[68px] md:px-[48px] px-5 pt-[15px] pb-[5px]">
                <div className="flex items-center sm:flex-row flex-col">
                    <ShimmerCircularImage className="w-[114px] h-[114px]" size='114' rounded/>
                    <div className="pl-6 overflow-auto sm:w-auto w-full">
                        <p className="md:text-xs15 sm:text-xs7 text-lg font-semibold text-[#FFFFFF]" size='sm'><ShimmerBadge size="md" width={100} /></p>
                        <div className="flex items-center">
                            <p className="pr-2 sm:text-sm text-xs2 font-normal text-[#FFFFFF]"><ShimmerBadge className="h-4"  width={250}/></p>
                        </div>
                        <div className="pt-4 flex overflow-auto pb-2.5">
                            {[...Array(3)].map((val)=>(
                                <div className="bg-[#FFFFFF] rounded px-3 py-2 min-w-[206px] mr-2" key={val}>
                                    <p className="text-sm font-semibold text-[#090406] pb-3 cash "><ShimmerBadge className="h-4"/></p>
                                    <p className="sm:text-lg text-base font-bold text-[#090406] text-end"><ShimmerBadge className="h-4"/></p>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="lg:px-[68px] md:px-[48px] px-1 pt-[26px]">
                <ul className="nav nav-pills flex sm:justify-start justify-between border-b border-[#FFFFFF]" id="pills-tab" role="tablist">
                    {[...Array(3)].map((item)=>(
                        <li className="nav-item mr-4" role="presentation" key={item}>
                            <ShimmerBadge className="h-4"/>
                        
                        </li>
                    ))}
                   
                </ul>
                <div className="tab-content mb-10" id="pills-tabContent">
                    <div className="tab-pane fade show active pt-[18px]" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div className="flex -mx-[18px] lg:flex-row flex-col"> 
                            <div className="lg:w-1/2 w-full px-[18px]"> 
                                <div className="border border-[#555259] sm:px-[38px] px-4 sm:pt-6 pt-4 sm:pb-[38px] pb-5 rounded-lg">
                                    <p className="md:text-xs16 text-base font-bold text-[#555259]"><ShimmerTitle line={1} gap={10} variant="primary"/></p>
                                    <div className="sm:pt-5 pt-4 flex -mx-1 flex-wrap">
                                        <div className="px-1 sm:w-1/3 w-1/2">
                                            <div className="w-full">
                                                <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                                <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={80} /></p>
                                            </div>
                                        </div>
                                        <div className="px-1 sm:w-1/3 w-1/2">
                                            <div className="w-full">
                                                <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                                <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={50}/></p>
                                            </div>
                                        </div>
                                        <div className="px-1 sm:w-1/3 w-1/2 sm:pt-0 pt-5">
                                            <div className="w-full">
                                                <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                                <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={80}/></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:pt-5 pt-4">
                                        <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                        <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406] break-words"><ShimmerBadge width={120}/></p>
                                    </div>
                                    <div className="sm:pt-5 pt-4">
                                        <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                        <div className="flex mt-2.5">
                                            {[...Array(3)].map((val)=>(
                                                <div className='mr-3' key={val}>
                                                    <ShimmerButton size="md"/>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="lg:w-1/2 w-full px-[18px] lg:mt-0 mt-3.5"> 
                                <div className="border border-[#555259] sm:px-[38px] px-4 sm:pt-6 pt-4 sm:pb-[56px] pb-5 rounded-lg lg:h-full h-auto">
                                    <p className="md:text-xs16 text-base font-bold text-[#555259]"><ShimmerTitle line={1} gap={10} variant="primary"/></p>
                                    <div className="sm:pt-5 pt-4">
                                        <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge/></p>
                                        <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={120}/></p>
                                    </div>
                                    <div className="flex -mx-1 sm:pt-5 pt-4">
                                        <div className="px-1 w-1/2">
                                            <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                            <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={80}/></p>
                                        </div>
                                        <div className="px-1 w-1/2">
                                            <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                            <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406] break-words"><ShimmerBadge width={80}/></p>
                                        </div>
                                    </div>
                                    <div className="flex -mx-1 sm:pt-5 pt-4">
                                        <div className="px-1 w-1/2">
                                            <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                            <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]"><ShimmerBadge width={150}/></p>
                                        </div>
                                        <div className="px-1 w-1/2">
                                            <p className="text-sm font-semibold text-[#808285]"><ShimmerBadge /></p>
                                            <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406] break-words"><ShimmerBadge width={150}/></p>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
  
}

export default ProfileSkeleton